import { ImageComponent } from "components/chat/chat-room/send-image-component";
import Image from "components/image/image.component";
import { useEffect, useState } from "react";
import { BiArrowToLeft, BiArrowToRight } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

export const ImageViewerPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentIndex, setIndex] = useState<number>(0);
  const images: string[] = location.state?.images;
  const index: number = location.state?.index ?? 0;
  const showRight = images.length > 1 && currentIndex !== images.length - 1;
  const showLeft = currentIndex !== 0;
  const circle =
    "bg-black w-8 h-8 p-1 rounded-full flex justify-center items-center text-white cursor-pointer";

  const next = () => {
    if (currentIndex < images.length - 1) {
      const index = currentIndex + 1;
      setIndex(index);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      const index = currentIndex - 1;
      setIndex(index);
    }
  };

  useEffect(() => {
    setIndex(index);
  }, [index]);

  return (
    <dialog open={true} className="modal">
      <>
        <div className="modal-box w-full h-full flex justify-center items-center max-w-full max-h-full">
          <ImageComponent>
            <Image
              key={currentIndex}
              src={images[currentIndex]}
              alt={`img-${currentIndex}`}
            />
          </ImageComponent>
        </div>
        <div
          className={`absolute flex ${
            showLeft && showRight
              ? "justify-between"
              : showLeft
              ? "justify-start"
              : "justify-end"
          } w-full items-center h-full top-10 px-10`}
        >
          {showLeft && (
            <BiArrowToLeft className={circle} fill="white" onClick={prev} />
          )}
          {showRight && (
            <BiArrowToRight
              className={circle}
              fill="white"
              onClick={next}
              style={{
                justifyContent: `${currentIndex === 0 ? "flex-end" : ""}`,
              }}
            />
          )}
        </div>
        <div className="absolute flex justify-left w-full h-4 top-2 mx-10">
          <MdClear
            className={circle}
            fill="white"
            onClick={() => navigate(-1)}
          />
        </div>
      </>
    </dialog>
  );
};
